import React from "react";
import useApi from "../useApi";
import { AnxietyGraphRes } from "../patients/index.type";

const useFetchAnxietyGraph = (billingCycleId: string) => {
  const [anxietyGraph, setAnxietyGraph] =
    React.useState<AnxietyGraphRes | null>(null);

  const { loading: anxietyGraphLoading, makeApiCall } = useApi({
    url: `/rtm//patient-dashboard/pdf/v3/anxiety-chart/${billingCycleId}`,
    method: "GET",
  });

  const getAnxietyGraphData = async () => {
    if (!billingCycleId) return;

    const { response } = await makeApiCall<undefined, AnxietyGraphRes>();

    if (response?.status === "success") {
      setAnxietyGraph(response);
    } else {
      setAnxietyGraph(null);
    }
  };

  return {
    anxietyGraph,
    getAnxietyGraphData,
    anxietyGraphLoading,
  };
};

export default useFetchAnxietyGraph;
